/**
 * The four-claim trust footer at the bottom of /licenses.
 *
 * Marketing copy, kept verbatim. "Always Current" is literally true of the download:
 * the certificate is rebuilt from current state each time rather than stored, which
 * is why the download button never serves a stale file.
 */
import { Crown, Lock, RefreshCw, ShieldCheck } from 'lucide-react';
import { c } from '../../styles/theme';

/** The four trust-footer claims. */
const TRUST_POINTS = [
  { Icon: RefreshCw, title: 'Always Current', desc: 'Latest info every time' },
  { Icon: ShieldCheck, title: 'Publicly Verifiable', desc: 'Anyone can verify online' },
  { Icon: Lock, title: 'Secure & Trusted', desc: 'Enterprise grade system' },
  { Icon: Crown, title: 'Lifetime Coverage', desc: 'No expiration. Ever.' },
] as const;

export default function LicenseTrustFooter() {
  return (
    <div
      style={{
        border: `1px solid ${c.accentBorder}`,
        borderRadius: 12,
        padding: '16px 18px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
        <ShieldCheck size={18} color={c.accent} />
        <p style={{ fontSize: 12, margin: 0 }}>
          Your license is always up to date. Every download regenerates the certificate with the
          latest status, version, and verification link.
        </p>
      </div>
      <div className="lyx-grid-2">
        {TRUST_POINTS.map(({ Icon, title, desc }) => (
          <div key={title} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Icon size={15} color={c.accent} />
            <div>
              <p style={{ fontSize: 12, fontWeight: 500, margin: 0 }}>{title}</p>
              <p style={{ fontSize: 10, color: c.text3, margin: 0 }}>{desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
